import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import useTranslate from '../../hooks/useTranslate';

const TnCLink = ({ lang = 'en', text, className }) => {
    const t = useTranslate();
    const title = text ? text : t('tnC');
    switch (lang) {
        default:
            return (
                <Link to="/terms-and-conditions" target="_blank" className={classNames({ [className]: className !== undefined })}>
                    {title}
                </Link>
            );
    }
};

export default TnCLink;
